"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourseService = void 0;
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
class CourseService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key, token = '') {
        this.getNeoCourses = async (user) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/neo/get-classes-by-student/${user.email}`;
            const requestOptions = {
                headers: {
                    'x-api-key': this.key,
                    'authorizationToken': `Bearer ${this.token}`
                }
            };
            const response = await axios_1.default.get(url, requestOptions);
            return Promise.resolve(response.data);
        };
        this.getThirdPartyCourses = async (user) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/catalogs/third-party-courses/${user.person_id}`;
            const requestOptions = {
                headers: {
                    'x-api-key': this.key
                }
            };
            const response = await axios_1.default.get(url, requestOptions);
            return Promise.resolve(response.data);
        };
        this.getEnrolledCourses = async (personId, type) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/catalogs/enrolled-courses/${personId}/${type}`;
            const requestOptions = {
                headers: {
                    'x-api-key': this.key
                }
            };
            const response = await axios_1.default.get(url, requestOptions);
            return Promise.resolve(response.data);
        };
        this.searchThirdPartyCourse = async (value) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/catalogs/third-party-courses/search/${value.replace(/\s/g, '+')}`;
            const response = await axios_1.default.get(url, { headers: { 'x-api-key': this.key } });
            return Promise.resolve(response.data);
        };
        this.getCoursesByInterest = async (personId) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/catalogs/courses-by-interest/${personId}`;
            const response = await axios_1.default.get(url, { headers: { 'x-api-key': this.key } });
            return Promise.resolve(response.data);
        };
        this.getAllCourses = async (queryStringParameters = '') => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/catalogs/third-party-courses${queryStringParameters}`;
            const response = await axios_1.default.get(url, { headers: { 'x-api-key': this.key } });
            return Promise.resolve(response.data);
        };
        this.getEnrolledCourseDetail = async (id) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/courses/${id}`;
            const response = await axios_1.default.get(url, { headers: { 'x-api-key': this.key } });
            return Promise.resolve(response.data);
        };
        this.getEnrolledCourseDetailByPersonId = async (id, personId) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/courses/${id}?personId=${personId}`;
            const response = await axios_1.default.get(url, { headers: { 'x-api-key': this.key } });
            return Promise.resolve(response.data);
        };
        this.saveUnsaveCourse = async (person_id, course_id, is_active) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/user/${person_id}/courses/saved`;
            const response = await axios_1.default.put(url, {
                "course_id": course_id,
                "is_active": is_active ? 1 : 0
            }, { headers: { 'x-api-key': this.key } });
            return Promise.resolve(response.data);
        };
        this.setRatingCourse = async (person_id, course_id, course_rating) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/user/${person_id}/courses/rating`;
            const response = await axios_1.default.put(url, {
                "course_id": course_id,
                "course_rating": course_rating
            }, { headers: { 'x-api-key': this.key } });
            return Promise.resolve(response.data);
        };
        this.getCoursesPagination = async (ou, params) => {
            const url = `${environment_1.API_MARKET_URL}/catalog/${ou}/courses`;
            const path = params ? `${url}?${this.objectToQueryString(params)}` : url;
            const response = await axios_1.default.get(path, { headers: { 'x-api-key': this.key } });
            return Promise.resolve(response.data);
        };
        this.getPersonCoursesInProgress = async (person_id) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/user/${person_id}/courses/progress/get-all-courses-by-userid`;
            const response = await axios_1.default.get(url, { headers: { 'x-api-key': this.key } });
            return Promise.resolve(response.data);
        };
        this.getPersonCourseProgressById = async (person_id, course_id) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/user/${person_id}/courses/progress/get-course-progress-by-id`;
            const response = await axios_1.default.post(url, {
                "course_id": course_id
            }, { headers: { 'x-api-key': this.key } });
            return Promise.resolve(response.data);
        };
        this.getCoursesRecommended = async (person_id) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/user/${person_id}/courses/recommended`;
            const response = await axios_1.default.get(url, { headers: { 'x-api-key': this.key } });
            return Promise.resolve(response.data);
        };
        this.getCoursesRecommendedByType = async (person_id, typeRecommendation, ou) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/user/${person_id}/courses/recommended?typeRecommendation=${typeRecommendation != null ? typeRecommendation : "generic"}&ou=${ou != null ? ou : "none"}`;
            const response = await axios_1.default.get(url, { headers: { 'x-api-key': this.key } });
            return Promise.resolve(response === null || response === void 0 ? void 0 : response.data);
        };
        this.getCoursesRecommendedByCourseId = async (person_id, typeRecommendation, course_id) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/user/${person_id}/courses/recommended?typeRecommendation=${typeRecommendation != null ? typeRecommendation : "generic"}&course_id=${course_id}`;
            const response = await axios_1.default.get(url, { headers: { 'x-api-key': this.key } });
            return Promise.resolve(response === null || response === void 0 ? void 0 : response.data);
        };
        this.getCoursesCompleted = async (person_id, params) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/user/${person_id}/courses/completed`;
            const path = params ? `${url}?${this.objectToQueryString(params)}` : url;
            const response = await axios_1.default.get(path, { headers: { 'x-api-key': this.key } });
            return Promise.resolve(response.data);
        };
        this.getCoursesAliados = async () => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/courses/aliados`;
            const response = await axios_1.default.get(url, { headers: { 'x-api-key': this.key } });
            return Promise.resolve(response.data);
        };
        this.getUserCourses = async (user) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/user/${user.person_id}/courses`;
            const response = await axios_1.default.get(url, { headers: { 'x-api-key': this.key } });
            return Promise.resolve(response.data);
        };
        this.syncPersonCoursesRelInBanner = async (person_id) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/courses/person/banner/${person_id}`;
            const response = await axios_1.default.post(url, {}, { headers: { 'x-api-key': this.key } });
            return Promise.resolve(response.data);
        };
        this.getAcademias = async () => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/catalogs/catalog/courses.CourseSkillCat?skill_type_id=1`;
            const response = await axios_1.default.get(url, { headers: { 'x-api-key': this.key } });
            return Promise.resolve(response.data);
        };
        this.setActivityCourseByersonId = async (person_id, course_id, last_activity_date_at) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/user/${person_id}/course`;
            const response = await axios_1.default.post(url, {
                "course_id": course_id,
                "last_activity_date_at": last_activity_date_at
            }, { headers: { 'x-api-key': this.key } });
            return Promise.resolve(response.data);
        };
        this.getUserFavoriteCourses = async (person_id) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/user/${person_id}/courses/saved`;
            const response = await axios_1.default.get(url, { headers: { 'x-api-key': this.key } });
            return Promise.resolve(response.data);
        };
        this.saveEnrollmentCourse = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/courses/person/enrollment`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.objectToQueryString = (obj) => Object.keys(obj).map(key => {
            const value = obj[key];
            let parameter = `${key}=${value}`;
            if (Array.isArray(value)) {
                let multiValueParams = '';
                const lastIndex = value.length - 1;
                value.forEach((item, index) => multiValueParams += `${key}=${item}${index === lastIndex ? '' : '&'}`);
                return multiValueParams;
            }
            return parameter;
        }).join("&");
        this.getCouresEduconByPersonIdAndCompanyId = async (person_id, company_id, status = 0, pageNumber = 1, pageSize = 8) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/users/${person_id}/courses/continuingeducation/${company_id}?status=${status}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
            const response = await axios_1.default.get(url, { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCouresEduconByPersonIdAndSourceId = async (person_id, source_id, status = 0, pageNumber = 1, pageSize = 8) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/users/${person_id}/courses/allys/${source_id}?status=${status}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
            const response = await axios_1.default.get(url, { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCoursesAllyInProgressByUser = async (person_id, pageNumber = 1, pageSize = 8) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/users/${person_id}/courses/allys/in_progress?pageNumber=${pageNumber}&pageSize=${pageSize}`;
            const response = await axios_1.default.get(url, { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCoursesEduconInProgressByUser = async (person_id, pageNumber = 1, pageSize = 8) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/users/${person_id}/courses/continuingeducation/in_progress?pageNumber=${pageNumber}&pageSize=${pageSize}`;
            const response = await axios_1.default.get(url, { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCoursesRecommendedByTypeConsumo = async (person_id, pageNumber = 1, pageSize = 10) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/users/${person_id}/courses/recommended/consumo?pageNumber=${pageNumber}&pageSize=${pageSize}`;
            const response = await axios_1.default.get(url, { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCoursesRecommendedByTypeInteres = async (person_id, pageNumber = 1, pageSize = 10) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/users/${person_id}/courses/recommended/interes?pageNumber=${pageNumber}&pageSize=${pageSize}`;
            const response = await axios_1.default.get(url, { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Proceso para obtener todas las declaraciones xAPI de un curso Talisis su identificador.
         * @param courseId. String. El identificador del curso.
         * @param email. String. El correo con el que se realiza el curso (usuario en sesión).
         * @returns Object con la información del curso (si es que se pudo obtener)
         */
        this.getTalisisCoursexAPIDataById = async (courseId, email) => {
            const url = `https://ywd8ofcxxd.execute-api.us-west-1.amazonaws.com/xapi/statements?course_id=${courseId}&email=${email}`;
            const response = await axios_1.default.get(url);
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Proceso para obtener las declaraciones xAPI del progreso de un curso Talisis su identificador.
         * @param courseId. String. El identificador del curso.
         * @param email. String. El correo con el que se realiza el curso (usuario en sesión).
         * @returns Object con la información del curso (si es que se pudo obtener)
         */
        this.getTalisisCourseProgressedDataById = async (courseId, email) => {
            const url = `https://ywd8ofcxxd.execute-api.us-west-1.amazonaws.com/xapi/statements/progressed?course_id=${courseId}&email=${email}`;
            const response = await axios_1.default.get(url);
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Proceso para obtener saber si un curso Talisis ha sido finalizado
         * @param courseId. String. El identificador del curso.
         * @param email. String. El correo con el que se realiza el curso (usuario en sesión).
         * @returns Object con la información del curso (si es que se pudo obtener)
         */
        this.passedTalisisCourse = async (courseId, email) => {
            const url = `https://ywd8ofcxxd.execute-api.us-west-1.amazonaws.com/xapi/statements/passed?course_id=${courseId}&email=${email}`;
            const response = await axios_1.default.get(url);
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.userCanEnroll = async (person_id) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/courses/person/can-enroll`;
            const response = await axios_1.default.post(url, {
                "person_id": person_id
            }, { headers: { 'x-api-key': this.key } });
            return Promise.resolve(response.data);
        };
        this.ENV = ENV;
        this.key = key;
        this.token = token;
    }
    /** No Funcional for now
     * Retriveas all **Courses** with specified filter
     * @param userId **Type:** `number` `required` User identified , test use userId = 461255
     * @param page **Type:** `number` Page number **value default:** 1
     * @param size **Type:** `number` Page size **value default:** 10
     * @param orderby **Type:** `string` Page order **value default:** id
     * @param filters **Type:** `object` Others filter **example:** filters= []
     * @returns **Type:** `object` **example:** {data:[],
                                                "currentPage": 1,
                                                "pageSize": 2,
                                                "totalCount": 2,
                                                "totalPages": 1}
     */
    async getAllByUserId(userId, page = 1, size = 10, orderby = 'id', filters = []) {
        let url = `${environment_1.API_URL_BASE}/${this.ENV}/catalogs/third-party-courses/${userId}`;
        for (let items of filters) {
            let filter = items;
            for (const key in filter) {
                let keyFilter = key;
                url += `&${key}=${filter[keyFilter]}`;
            }
        }
        const requestOptions = {
            method: 'GET',
            headers: { 'x-api-key': this.key },
        };
        let response = {
            statusCode: 200,
            message: 'successlful',
            userMessage: '',
            data: [],
            currentPage: page,
            pageSize: size,
            totalCount: 2,
            totalPages: 1
        };
        try {
            const responseApiGateway = await fetch(url, requestOptions);
            const dataApi = await responseApiGateway.json();
            response.data = dataApi;
            response.totalCount = dataApi.length;
        }
        catch (e) {
            response.message = e.message;
        }
        return response;
    }
}
exports.CourseService = CourseService;
